import styled from 'styled-components';

export default styled.div`
  margin-bottom: 80px;
  text-align: center;

  li {
    display: inline-block;
    font-size: 1.3rem;
    font-weight: 500;
    margin: 0 0.5em;
    &.disabled {
      display: none;
    }
    &.active {
      a {
        color: ${props => props.theme.primary};
      }
    }
    a {
      color: ${props => props.theme.gray700};
      text-decoration: none;

      &:focus {
        outline: none;
      }
    }
  }
`;
